<template>
  <div>
    <p>
      <b-button
        ariant="outline-info"
        block
        @click="open()" 
      >
        New Media File
      </b-button>
    </p>
  </div>
</template>

<script>
import { EventBus } from "@/events/eventBus";
import NewRecordingForm from "@/components/conversations/NewRecordingForm";

export default {
  name: "NewRecordingButton",
  methods: {
    open() {
      const $ = window.$;
      $("#id-modal-container").modal({
        backdrop: "static"
      });
      EventBus.$emit("open", {
        component: NewRecordingForm,
        title: "New Recording",
        actionButton: "Interpret Recording",
        closeOnClick: true,
      });
    }
  }
};
</script>

<style scoped>
p {
  margin-left: 15px;
  margin-right: 15px;
  margin-top: 15px;
}
</style>
